<template>
    <div class="invalid-invitation">
        <div class="outer-layer">
            <b-container fluid class="main-container">
                <b-row class="justify-content-center" align-v="center" >
                    <b-col cols="0" lg="3" class="d-md-flex d-sm-none"></b-col>
                    <b-col cols="12" lg="6">
                        <b-img :src="logo" class="logo">

                        </b-img>
                    </b-col>
                    <b-col cols="0" lg="3" class="d-md-flex d-sm-none"></b-col>
                </b-row>
                <b-row class="justify-content-center">
                    <b-col cols="1" lg="3"></b-col>
                    <b-col cols="10" lg="6">
                        <b-card>
                            <b-container>
                                <b-row>
                                    <b-col cols="12">
                                        <span>
                                            You've been sent an updated invitation. Please check your inbox for a new email from Sellers Shield. if you have already created an account, use the button below to login.
                                        </span>
                                    </b-col>
                                </b-row>
                                <b-row class="justify-content-center"  align-v="center"  align-h="center">
                                    <b-col class="d-flex justify-content-center">
                                        <button class="gold-button" @click="goToLogin">Login</button>
                                    </b-col>                
                                </b-row>
                            </b-container>

                        </b-card>
                    </b-col>
                    <b-col cols="1" lg="3"></b-col>
                </b-row>
            </b-container>

        </div>
    </div>
</template>

<script>
import './InvalidInvitation.scss';
import {pageRedirect} from "@helpers/router-helper";
export default{
    name: 'NewInvitation',
    methods:{
        async goToLogin(){
            await pageRedirect(window.env.APP_URL, '/auth');
        }
    },
    computed:{
        logo(){
            return require('@assets/images/v3/SS Wordmark-White 1.svg');
        }
    }
}
</script>
